import { Scroll } from "@lib/scroll";

let timeout: ReturnType<typeof setTimeout> | null = null;
const DEBOUNCE_MS = 200;

if ("PerformanceObserver" in window) {
  try {
    const observer = new PerformanceObserver((list) => {
      for (const entry of list.getEntries()) {
        if ((entry as any).hadRecentInput) continue;
        // Debounce — batch rapid shifts into one resize
        if (timeout) clearTimeout(timeout);
        timeout = setTimeout(() => {
          Scroll.resize();
          timeout = null;
        }, DEBOUNCE_MS);
      }
    });
    observer.observe({ entryTypes: ["layout-shift"] });
  } catch {}
}
